// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const shoppingCenterApi = {
  list: () => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers`, 'GET').execute(),
  checkShoppingCenterData: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/data`, 'GET').execute(),
  fetchAmbassadors: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/ambassadors`, 'GET').execute(),
  fetchMedias: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/keepeek-medias`, 'GET').execute(),
  fetchEmbeddedUrls: (pcId: string, page: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/embedded-url`, 'GET')
    .addParam('page', page)
    .execute(),
  fetchBranchLevel: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/branch-levels`, 'GET').execute(),
  fetchFacts: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/facts`, 'GET').execute(),
  fetchIsochronousZones: (pcId: string, year: number) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/facts/isochronous-zones`, 'GET')
    .addParam('year', year)
    .execute(),
  fetchSchedules: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/schedules`, 'GET').execute(),
  fetchStores: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/stores`, 'GET').execute(),
  fetchPracticalInfos: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/practical-infos`, 'GET').execute(),
  fetchMarketing: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/marketing`, 'GET').execute(),
  hasMapData: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/shopping-centers/${pcId}/map/data`, 'GET').execute(),
};

export default shoppingCenterApi;
